module.exports = __webpack_public_path__ + "static/media/redowhite.973b7cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logos/redowhite.png
// module id = 104
// module chunks = 0